/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, of } from 'rxjs';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import {
  AnalystAddition,
  addAnalyst,
  retrieveAnalysts,
  saveAnalystFailure,
  saveAnalystSuccess,
} from '@store/scenario/analyst/analyst-slice';
export const addAnalystEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) => action$.pipe(
  ofType(addAnalyst.type),
  concatMap((action: PayloadAction<AnalystAddition>) => from(
    dependencies.analystGateway.create(
      action.payload.userId,
      action.payload.sourceId,
      action.payload.firstName,
      action.payload.lastName,
      action.payload.zoneIds,
    ),
  ).pipe(
    concatMap(() => of(saveAnalystSuccess(), retrieveAnalysts())),
    catchError(() => of(saveAnalystFailure('Failed to add analyst'))),
  )),
);
